import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=30ef0dac&scoped=true"
import script from "./EditCategory.vue?vue&type=script&lang=js"
export * from "./EditCategory.vue?vue&type=script&lang=js"
import style0 from "./EditCategory.vue?vue&type=style&index=0&id=30ef0dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef0dac",
  null
  
)

export default component.exports